import React from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Features from "@/components/site/Features";
import HowItWorks from "@/components/site/HowItWorks";
import Screenshots from "@/components/site/Screenshots";
import Testimonials from "@/components/site/Testimonials";
import Pricing from "@/components/site/Pricing";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import Ticker from "@/components/site/Ticker";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-black text-white">
      <Nav />
      <Hero />
      <Ticker />
      <Features />
      <HowItWorks />
      <Screenshots />
      <Testimonials />
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  );
}
